import React, { useState, useEffect, Suspense } from "react";
import Viamobi from "@viamericas/viamobi-component";
import { useAutoScrollToResult } from "./hooks/useAutoScrollToResult";
import { useKYCLists } from "./hooks/useKYCLists";
import { deriveActiveProcess } from "./services/processCodes";
import Cookies from "universal-cookie";
import i18n from "./i18n";
import { withTranslation } from "react-i18next";
import Header from "./components/Header";
import Footer from "./components/Footer";
import upload from './assets/images/document-cloud-white.svg' ;
import uploadDisabled from './assets/images/document-cloud.svg';
import uploadFile from './assets/images/upload.svg';
import uploadCamera from './assets/images/webcam-dark.svg';
import cameraDisabled from './assets/images/webcam.svg';
import camera from './assets/images/webcam-white.svg';
import photo from './assets/images/icon-scan.svg';
import  rotate from './assets/images/rotate.svg';
import userDisabled from './assets/images/user.svg';
import user from './assets/images/user-white.svg';
import cardDisabled from './assets/images/personalcard.svg';
import card from './assets/images/personalcard-white.svg';
import closeCircle from './assets/images/close-circle.svg';
import tickCircle from './assets/images/tick-circle.svg';

const pdfDefaultPhoto = require("./assets/images/pdfDefault.png");

const cookies = new Cookies();

function App({
  optionQS,
  agencyQS,
  orderQS,
  amountQS,
  language,
  idSenderGlobal,
  nameSender,
  iddoc,
  env,
  region,
  iris,
  selfie,
  idShortener,
  isBackCapture,
  documentTypeId,
  username,
  reqsource,
  transactionUuid,
  idOnly,
  complianceSessionId,
  ownerSecret
}) {
  const [idBranch, setIdBranch] = useState(agencyQS || "");
  const [order] = useState(orderQS || "");
  const [amount] = useState(amountQS || " ");
  const [phone, setPhone] = useState("");
  const [activeProcess, setActiveProcess] = useState([]);
  // Source channel of the transaction, emitted by the component after prefill.
  // isWapp === true => the transaction originated from WhatsApp.
  const [txSource, setTxSource] = useState({ isWapp: false, sourceApp: null });
  const [token] = useState(process.env.REACT_APP_TOKEN_PASS);
  const [environment] = useState(env || "A" );
  const [r] = useState(region || "" );
  let url = process.env.REACT_APP_URL_VIACHEK_MOBILE.replace("{NAME_REGION}",r );

  /** KYC is enabled when activeProcess includes KY or KG */
  const isKYCEnabled = activeProcess.some(p => p === 'KY' || p === 'KG');

  /** Fetch KYC dropdown lists from agency services API when KYC is required */
  const { listPurposes, listOrigins, listOcupations, listRelations } = useKYCLists({
    baseUrl: url,
    token,
    enabled: isKYCEnabled
  });

  const handleKYCComplete = (result) => {
    // KYC form submitted successfully — result contains the structured KYC data
    // The Viamobi component handles the API submission internally via submitKYC
  };

  const handleKYCError = (error) => {
    console.error('KYC error:', error);
  };

  useEffect(() => {
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  const setIdBranchData = (data) => {
    setIdBranch(data);
  };

  const isMobile = () => {
    return (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/BlackBerry/i)
    );
  };

  useEffect(() => {
    setPhone(cookies.get("phoneViaMobi"));
  }, []);

  useEffect(() => {
    if (!agencyQS) {
      setIdBranch(cookies.get("agencyViaMobi"));
    }

    if (!optionQS) {
      setActiveProcess(deriveActiveProcess(null));
    } else {
      setActiveProcess(deriveActiveProcess(optionQS));
    }
  }, [agencyQS, optionQS]);

  const isProduction = window.location.protocol === 'https:';

  useEffect(() => {
    if (idBranch?.length === 6) {
      cookies.set("agencyViaMobi", idBranch, {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
        sameSite: "strict",
        secure: isProduction,
      });
    }
  }, [idBranch, isProduction]);

  useEffect(() => {
    if (phone?.length === 10 || !phone) {
      cookies.set("phoneViaMobi", phone, {
        path: "/",
        maxAge: 60 * 60 * 24 * 365,
        sameSite: "strict",
        secure: isProduction,
      });
    }
  }, [phone, isProduction]);

  useAutoScrollToResult('.result__container, .result__response-message');

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Header />
      <Viamobi
        idBranch={idBranch}
        setIdBranch={setIdBranchData}
        orderParam={order}
        amountParam={amount}
        phone={phone}
        setPhone={setPhone}
        idSenderGlobal={idSenderGlobal}
        nameSender={nameSender}
        iddoc={iddoc}
        unknowPhoto={uploadCamera}
        pdfDefaultPhoto={pdfDefaultPhoto}
        isMovile={isMobile()}       
        activeProcess={activeProcess}
        token={token}
        url={url}
        env={ (environment === "beta" ? "B": ( environment === "prod" ? "P":"A") )}
        icons={{
          upload,
          uploadDisabled,
          uploadFile,
          camera,
          photo,
          rotate,
          cameraDisabled,
          userDisabled,
          user,
          card,
          cardDisabled,
          uploadCamera,
          closeCircle,
          tickCircle
        }}
        isIrisCapture={iris==='Y' ? true : false}        
        isSelfieCapture={selfie==='Y' ? true : false}
        isBackCapture={isBackCapture==='Y' ? true : false}
        idShortener={idShortener}
        documentTypeId={documentTypeId}
        reqsource={reqsource}
        username={username}
        uuid={process.env.REACT_APP_VIAMOBI_UUID || ''}
        enableKYC={isKYCEnabled}
        onKYCComplete={handleKYCComplete}
        onKYCError={handleKYCError}
        agency={agencyQS}
        cashier={username || nameSender || ''}
        transaction={order}
        date={new Date().toLocaleDateString()}
        application="compliance"
        isUpdate={false}
        dynamicFields={{
          isSenderName: false,
          isSSNCheckRequired: true,
          isTabBeneficiary: true,
          isOriginFund: true
        }}
        listPurposes={listPurposes}
        listOrigins={listOrigins}
        listOcupations={listOcupations}
        listRelations={listRelations}
        transactionUuid={transactionUuid}
        trackingUrl={process.env.REACT_APP_TRACKING_URL || ''}
        forceModernDesign={process.env.REACT_APP_FORCE_MODERN_DESIGN === 'true'}
        skipSelfieOnKyc={idOnly === 'Y'}
        onTransactionInfo={setTxSource}
        complianceSessionId={complianceSessionId}
        ownerSecret={ownerSecret}
      />
      <Footer />
    </Suspense>
  );
}

export default withTranslation()(App);
